<template>
  <div id="modalDeleteTemplate" class="modal-dialog myMoDi" v-if="showDialog">
    <div class="modalHeader">
      <span class="title">Delete Template</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label for="duplicateSource">Template:</label>
        <select id="duplicateSource" class="form-control form-control-sm" v-model="template">
          <option v-if="template.name !== 'global'" :value="{id:template._id,name:template.name}" v-for="(template, index) in $store.state.templates" :key="index">
            {{ template.name }}
          </option>
        </select>
      </div>
      <button class="btn btn-danger" @click="deleteTemplate">Delete</button>
      <button class="btn btn-secondary" @click="closeModal">Cancel</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-delete-template',

  data () {
    return {
      showDialog: false,
      template: {}
    }
  },

  mounted () {
    let that = this
    this.$bus.on('showTemplateDeleteDialog', function () {
      that.showDialog = true
    })
  },

  methods: {
    deleteTemplate () {
      if (!Object.keys(this.template).length) {
        this.$bus.emit('addNotification', {
          title: 'Template Delete Error',
          body: 'No template was selected. Please try again',
          type: 'error'
        })
        return
      }

      let keepGoing = true
      if (this.$store.state.templates[this.$store.state.currentTemplateName]['_id'] === this.template.id) {
        this.$store.commit('setCurrentTemplateName', 'global')
        this.$bus.emit('setCurrentTemplateName', 'global')
        let that = this
        this.$store.dispatch('applyTemplate').then(function (result) {
          if (!result) {
            that.$bus.emit('addNotification', {
              title: 'Error Applying Global Template',
              body: 'An error occured while applying the global template. Please try again.',
              type: 'error'
            })
            keepGoing = false
          }
        })
      }

      if (!keepGoing) return

      const apiUrl = this.$store.state.apiUrl
      this.axios.post(apiUrl + 'template/delete/' + this.template.id).then(response => {
        if (response.data.success) {
          this.$store.commit('removeTemplate', this.template.name)
          if (typeof this.$store.state.questionnaires[this.template.name] !== 'undefined') {
            const questionnaire = this.$store.state.questionnaires[this.template.name]
            this.axios.post(apiUrl + 'questionnaire/delete/' + questionnaire._id).then(response => {
              if (response.data.success) {
                this.$bus.emit('addNotification', {
                  title: 'Template Deleted',
                  body: 'The template was deleted successfully',
                  type: 'success'
                })
                this.closeModal()
              } else {
                this.$bus.emit('addNotification', {
                  title: 'Template Questionnaire Delete Error',
                  body: 'There was an error deleting the templates questionnaire. Please review the data and try again',
                  type: 'error'
                })
              }
            })
          } else {
            this.$bus.emit('addNotification', {
              title: 'Template Deleted',
              body: 'The template was deleted successfully',
              type: 'success'
            })
            this.closeModal()
          }
        } else {
          this.$bus.emit('addNotification', {
            title: 'Template Delete Error',
            body: 'There was an error deleting the template. Please review the data and try again',
            type: 'error'
          })
        }
      })
      this.$store.commit('setLastSaved', Date.now())
    },

    closeModal () {
      this.showDialog = false
      this.template = {}
    }
  },

  beforeDestroy () {
    this.$bus.$off('showTemplateDeleteDialog')
  }
}
</script>

<style lang="scss" scoped>
  .modal-dialog {
    user-select: none;
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -25%;
    width: 50%;
    height: 180px;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    overflow: hidden;
    z-index: 1;

    .modalHeader {
      background-color: #2d5f8b;
      color: white;
      font-size: 18px;
      padding: 5px 10px 5px 10px;

      .btn-close {
        cursor: pointer;
        color: #FFF;
      }
    }

    .modalBody {
      padding: 10px;
    }
  }

  .myMoDi{
    pointer-events: auto;
    max-width: initial;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/modals/ModalDeleteTemplate.vue